import styled from 'styled-components';
import { styledScroll } from 'styles/styledScroll';

export const Container = styled.div`
  width: calc(100% + 12px);
  min-height: -webkit-fill-available;
  max-height: calc(100vh - 16px);
  top: 8px;
  position: sticky;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  ${styledScroll}

  > div {
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;
